<template>
  <div class="col">
    <fieldset>
      <legend>
        {{ $t('registrationForm.myArriva') }}
      </legend>
      <div class="form-row inline-label required">
        <div class="form-column wm-field-label">
          <label for="account-emailAddress" class="required">{{ $t('registrationForm.email') }}</label>

          <text-input
            :value="emailAddress"
            name="emailAddress"
            prefix="account"
            @input="(v) => setEmailAddress(v)"/>
          <registration-form-validation-messages :messages="emailAddressValidationErrors"/>
        </div>
      </div>
      <div class="form-row inline-label required">
        <div class="form-column wm-field-label">
          <label for="account-password" class="required">{{ $t('registrationForm.password') }}</label>

          <text-input :errors="passwordValidationErrors"
                      v-model="password"
                      type="password"
                      name="password"
                      prefix="account"/>

          <registration-form-validation-messages :messages="passwordValidationErrors"/>
          <tooltip :title="$t('registrationForm.passwordTooltip')" :position="'right'"/>
        </div>
      </div>
      <div class="form-row inline-label required">
        <div class="form-column wm-field-label">
          <label for="account-confirmPassword" class="required">{{ $t('registrationForm.passwordConfirm') }}</label>

          <text-input :errors="passwordValidationErrors"
                      v-model="passwordConfirm"
                      type="password"
                      name="confirmPassword"
                      prefix="account"/>

          <registration-form-validation-messages :messages="passwordConfirmValidationErrors"/>
        </div>
      </div>
    </fieldset>
    <fieldset class="submit">
      <div class="form-row">
        <div class="form-column">

          <input id="registerWithAccount"
                 :value="$t('registrationForm.nextWithRegistration')"
                 type="submit"
                 name="registerWithAccount"
                 class="link-button"
                 @click.prevent="submit">
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
/* @flow */
import { mapState } from 'vuex'
import { SET_EMAIL_ADDRESS } from '../store/modules/registration/mutation-types'
import TextInput from './registration-form/TextInput'
import RegistrationFormValidationMessages from './registration-form/ValidationMessages'
import Tooltip from '../components/Tooltip'
import uniqBy from 'lodash.uniqby'

const mapValidationErrors = (propertyNames) => {
  return Object.assign({}, ...propertyNames.map(propertyName => (
    {
      [propertyName + 'ValidationErrors']: function () {
        const errors = this.registrationValidationErrors.filter(error => error.propertyPath === 'account.' + propertyName)
        return uniqBy(errors, 'code')
      }
    }
  )))
}

export default {
  name: 'CustomerCreateAccountForm',
  components: {
    RegistrationFormValidationMessages,
    TextInput,
    Tooltip
  },
  props: {},
  data: function () {
    return {
      password: '',
      passwordConfirm: ''
    }
  },
  computed: {
    ...mapState({
      emailAddress: state => state.registration.emailAddress,
      registrationValidationErrors: state => state.registration.registrationValidationErrors
    }),
    ...mapValidationErrors(['emailAddress', 'password', 'passwordConfirm'])
  },
  methods: {
    setEmailAddress (value) {
      this.$store.commit('registration/' + SET_EMAIL_ADDRESS, value)
      this.$emit('email-address-changed', value)
    },
    submit () {
      this.$emit('submit', { emailAddress: this.emailAddress, password: this.password, passwordConfirm: this.passwordConfirm })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/CustomerCreateAccountForm.vue